import { render, staticRenderFns } from "./MultiBranchHelpList2.vue?vue&type=template&id=25f105be&"
import script from "./MultiBranchHelpList2.vue?vue&type=script&lang=js&"
export * from "./MultiBranchHelpList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports